export default __webpack_public_path__ + "static/media/tool_item_2.2346a7f6.png";